import React, { useState, useEffect } from 'react';

const FoodForm = ({ initialData, onSubmit, onCancel, submitting = false }) => {
  const [form, setForm] = useState({
    name: '',
    description: '',
    price: '',
    stock: '',
    image: '',
    isAvailable: true,
  });

  useEffect(() => {
    if (initialData) {
      setForm({
        name: initialData.name || '',
        description: initialData.description || '',
        price: initialData.price || '',
        stock: initialData.stock || '',
        image: initialData.image || '',
        isAvailable: initialData.isAvailable !== undefined ? initialData.isAvailable : true,
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...form,
      price: parseFloat(form.price),
      stock: parseInt(form.stock, 10) || 0,
    };
    onSubmit(payload);
    if (!initialData) {
      setForm({ name: '', description: '', price: '', stock: '', image: '', isAvailable: true });
    }
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white p-4 rounded-[15px] border border-[#dae1e7] shadow-[0px_1px_3px_0px_rgba(3,0,71,0.09)]">
      <h2 className="text-lg font-semibold text-[#2b3445] mb-3">
        {initialData ? 'Edit Item' : 'Add New Item'}
      </h2>
      <div className="space-y-3">
        <div>
          <label className="block text-sm font-semibold text-[#2b3445] mb-1">Name *</label>
          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            className="w-full border border-[#dae1e7] rounded-[8px] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#1471b9]/20"
            required
            disabled={submitting}
          />
        </div>
        <div>
          <label className="block text-sm font-semibold text-[#2b3445] mb-1">Description</label>
          <input
            type="text"
            name="description"
            value={form.description}
            onChange={handleChange}
            className="w-full border border-[#dae1e7] rounded-[8px] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#1471b9]/20"
            disabled={submitting}
          />
        </div>
        <div>
          <label className="block text-sm font-semibold text-[#2b3445] mb-1">Price (₹) *</label>
          <input
            type="number"
            name="price"
            min="0"
            step="0.01"
            value={form.price}
            onChange={handleChange}
            className="w-full border border-[#dae1e7] rounded-[8px] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#1471b9]/20"
            required
            disabled={submitting}
          />
        </div>
        <div>
          <label className="block text-sm font-semibold text-[#2b3445] mb-1">Stock</label>
          <input
            type="number"
            name="stock"
            min="0"
            step="1"
            value={form.stock}
            onChange={handleChange}
            className="w-full border border-[#dae1e7] rounded-[8px] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#1471b9]/20"
            disabled={submitting}
          />
        </div>
        <div>
          <label className="block text-sm font-semibold text-[#2b3445] mb-1">Image URL</label>
          <input
            type="text"
            name="image"
            value={form.image}
            onChange={handleChange}
            className="w-full border border-[#dae1e7] rounded-[8px] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#1471b9]/20"
            placeholder="https://example.com/food.jpg"
            disabled={submitting}
          />
        </div>
        <div className="flex items-center">
          <input
            type="checkbox"
            name="isAvailable"
            id="isAvailable"
            checked={form.isAvailable}
            onChange={handleChange}
            className="mr-2 h-4 w-4 text-[#1471b9] border-[#dae1e7] rounded focus:ring-[#1471b9]"
            disabled={submitting}
          />
          <label htmlFor="isAvailable" className="text-sm text-[#2b3445]">Available</label>
        </div>
        <div className="flex gap-2 pt-2">
          <button
            type="submit"
            disabled={submitting}
            className="bg-[#1471b9] text-white px-4 py-2 rounded-[8px] text-sm font-bold hover:opacity-90 transition disabled:opacity-50"
          >
            {submitting ? 'Saving...' : (initialData ? 'Update' : 'Add')}
          </button>
          {initialData && onCancel && (
            <button
              type="button"
              onClick={onCancel}
              disabled={submitting}
              className="bg-gray-200 text-gray-700 px-4 py-2 rounded-[8px] text-sm font-bold hover:bg-gray-300 transition disabled:opacity-50"
            >
              Cancel
            </button>
          )}
        </div>
      </div>
    </form>
  );
};

export default FoodForm;